import { useMutation, UseMutationResult } from 'react-query';
import { ApiError } from '../../services/api-error.model';
import { AskAnalystDto } from '../../services/dtos/analysts/askAnalyst.dto';
import { createAskAnAnalyst } from '../../services/analysts/askAnalyst.service';

export default (): UseMutationResult<AskAnalystDto, ApiError, AskAnalystDto, void> => {
  return useMutation(async (askAnAnalystData: AskAnalystDto) => {
    return createAskAnAnalyst(askAnAnalystData);
  });
};
